import { useDispatch, useSelector } from 'react-redux'
import { authActions } from 'store/reducers/auth'
import { ROLE_KEYS, TYPE_KEYS } from './permissions/constant'
import { replaceToLandingSSR } from 'utils/navigateLandingSSR'

const useAuth = () => {
  const dispatch = useDispatch()
  const userData = useSelector((state) => state.auth)
  function getUserType() {
    return userData?.profile?.user_type
  }
  function getRoleUser() {
    return userData?.roles
  }
  function getAccessToken() {
    return userData?.access_token
  }
  function getProfileUser() {
    return userData?.profile
  }
  function onLogin(access_token, refresh_token) {
    return dispatch(authActions.login({ access_token: access_token, refresh_token: refresh_token }))
  }
  function setRoleUser(roles) {
    const payload = { roles: roles }
    return dispatch(authActions.setRoles(payload))
  }
  function setProfileUser(profile) {
    const payload = { profile: profile }
    return dispatch(authActions.setProfile(payload))
  }
  function checkUserActivePackageByFeature(feature = '') {
    return userData?.profile?.package_subscriptions
      ? userData?.profile?.package_subscriptions.some((item) =>
          [feature, ROLE_KEYS.ADVISOR].includes(item.role)
        )
      : []
  }
  function checkIfUserHasRole(ROLE) {
    return !!userData?.roles.includes(ROLE)
  }
  function getUserRoleArr() {
    return userData?.roles?.map((role) => role.code) || []
  }
  function onLogout() {
    dispatch(authActions.logout())
    localStorage.clear()
    return replaceToLandingSSR()
  }
  function getUserAccessType(requestStatus, feature) {
    if (!userData?.access_token) return TYPE_KEYS.GUEST
    if (requestStatus) return TYPE_KEYS.APPROVED_USER
    return checkUserActivePackageByFeature(feature) ? TYPE_KEYS.PAID : TYPE_KEYS.FREE
  }

  return {
    userProfile: getProfileUser(),
    userType: getUserType(),
    getUserAccessType,
    checkUserActivePackageByFeature,
    getAccessToken,
    getRoleUser,
    onLogin,
    onLogout,
    setProfileUser,
    setRoleUser,
    checkIfUserHasRole,
    userRoleArr: getUserRoleArr()
  }
}

export default useAuth
